import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { FinalFormFormField } from '../FormField';
import { InputRenderer } from './InputRenderer';
export const TextField = memo(function TextField({ input, meta, label, labelTooltip, required, disabled, width, iconStart, iconEnd, renderError, ...props }) {
    return (_jsx(FinalFormFormField, { meta: meta, label: label, labelTooltip: labelTooltip, required: required, disabled: disabled, name: input.name, renderError: renderError, children: _jsx(InputRenderer, { ...input, error: meta.touched && (meta.error || meta.submitError), disabled: disabled, width: width, iconStart: iconStart, iconEnd: iconEnd, ...props }) }));
});
